// Vue
import {mixins} from 'vue-class-component'
import {Vue, Component, Prop, Watch} from 'vue-property-decorator'

// Template
import template from './template.vue'

// Components
import {Icon} from '../icon/Icon'

// Mixins
import {EventBus} from '../../../mixins/event_bus/EventBus'

@Component({
    name: 'Tile',
    components: {
        Icon
    },
    mixins: [
        template
    ]
})
export class Tile extends mixins(EventBus) {

    private get tagElement() {
        if( this.href ){
            return 'a'
        }

        if( this.to ){
            return 'router-link'
        }

        return 'div'
    }

    private flipped: boolean = false

    private internalHeight: number = 280

    @Prop()
    public iconFront!: string

    @Prop()
    public iconBack!: string

    @Prop({default: 'default'})
    public theme!: string

    @Prop()
    public title!: string

    @Prop()
    public target!: string

    @Prop()
    public href!: string

    @Prop()
    public to!: object

    @Prop({default: 280})
    public height!: number

    @Prop({default: 'default'})
    public img!: string

    @Watch('height')
    private watchHeight(newHeight, oldHeigth) {

        if (this.internalHeight != newHeight) {
            this.internalHeight = newHeight
        }
    }

    public created() {
        this.$on('groupHeightChange', this.handleGroupHeightChange)
        this.internalHeight = this.height
    }

    public mounted() {

    }

    public destroyed() {
        this.$off('groupHeightChange', this.handleGroupHeightChange)
    }

    public handleGroupHeightChange(groupHeight: number) {
        this.internalHeight = groupHeight
    }

    public get isErrortheme()
    {
        return this.theme === 'error';
    }
    public get isLockedtheme()
    {
        return this.theme === 'locked';
    }

    public onClick(event) {
        if (this.isLockedtheme && this.$slots.back) {
            event.preventDefault();
            this.flipped = !this.flipped
        }
    }
}